import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imVatRateFilter', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/filters/vat-filter/vat-filter.html'),
        controller: 'VatFilterController',
        controllerAs: 'VatFilterCtrl',
        bindings: {
            vatRate: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/vat-filter/vat-filter.component.ts